import { de, enGB, nl, fr } from 'date-fns/locale';
import { format } from 'date-fns';
import { useI18n } from 'vue-i18n';

const languages = {
	nl: nl,
	de: de,
	en: enGB,
	fr: fr,
	'nl-NL': nl,
	'de-DE': de,
	'en-GB': enGB,
	'fr-FR': fr,
} as const;

export function useLocalizedDate() {
	const i18n = useI18n();

	function localizeDate(date: number | string | Date, formatStr: string) {
		const wrappedDate = typeof date === 'string' ? new Date(date) : date;

		return format(wrappedDate, formatStr, {
			locale: languages[i18n.locale.value],
		});
	}

	return { localizeDate };
}
